import { DataMessageTypeEnum } from '@terra/shared-dto-chat-types';

export const GENERIC_TOOL_FAILURE_EXPLANATION = 'This step did not finish.';

const isUnsafeFailureText = (value: string): boolean =>
  value.length > 180 ||
  value.includes('\n') ||
  /https?:\/\//i.test(value) ||
  /\b\d{1,3}(?:\.\d{1,3}){3}\b/.test(value) ||
  /[a-f0-9]{24}/i.test(value);

export function friendlyToolFailureExplanation(
  display: string | undefined,
): string {
  const text = display?.trim() ?? '';

  if (text.length === 0 || isUnsafeFailureText(text)) {
    return GENERIC_TOOL_FAILURE_EXPLANATION;
  }

  return text;
}

export function isFailedToolCallMessage({
  status,
  type,
}: {
  status?: string;
  type?: string;
}): boolean {
  return status === 'error' || type === DataMessageTypeEnum.ToolCallError;
}
